import React from 'react';
import { Route, Routes } from 'react-router-dom';

import LoadingPage from 'pages/LoadingPage';

import organisationSettingsRoutes from './organisation-settings-routes';

type IntegrationSettingsRouteComponent = {
  component: React.LazyExoticComponent<React.FC<Record<string, never>>>;
};

const integrationSettingsRouteComponents: Record<
  keyof typeof organisationSettingsRoutes,
  IntegrationSettingsRouteComponent
> = {
  createJobs: {
    component: React.lazy(() => import('./create-jobs-page')),
  },
  integrationSettings: {
    component: React.lazy(() => import('./integration-settings-page')),
  },
  sdbIntegration: {
    component: React.lazy(() => import('./sdb-integration-page')),
  },
  selectJobs: {
    component: React.lazy(() => import('./select-jobs-page')),
  },
};

export const IntegrationSettingsRoutes = (): JSX.Element => {
  return (
    <Routes>
      {Object.entries(organisationSettingsRoutes).map(([key, route]) => (
        <Route
          key={route.name}
          path={route.path}
          element={
            <React.Suspense fallback={<LoadingPage />}>
              {React.createElement(
                integrationSettingsRouteComponents[key].component,
              )}
            </React.Suspense>
          }
        />
      ))}
    </Routes>
  );
};

const IntegrationSettings = (): JSX.Element => {
  return <IntegrationSettingsRoutes />;
};

export default IntegrationSettings;
